import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { coachingResources, sessionAreas, volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-274" data-mp="coraiszp714t">
      <div className="max-w-6xl mx-auto" data-id="element-275" data-mp="cmes6eq12or8">
        <div className="text-center mb-16" data-id="element-276" data-mp="7owkernqyfkt">
          <p className="text-azure font-bold tracking-widest uppercase text-sm mb-3" data-id="element-277" data-mp="7q7jwfa5t164">
            The Coaching Library
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-navy" data-id="element-278" data-mp="3c3mlum7utz1p">
            📚 6 Complete Volumes of{' '}
            <span className="text-gold-solid" data-id="element-279" data-mp="3pvaswb38xxbt">Ready-to-Coach</span> Wrestling Sessions
          </h2>
          <p className="text-xl text-slate" data-id="element-280" data-mp="3l42hxam9q3wj">
            Organized by development area ·{' '}
            <span className="text-gold-solid font-bold" data-id="element-281" data-mp="2xdyhtd8agmaa">150</span> complete sessions ·
            Beginner to advanced · Nothing to build from scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-282" data-mp="29fs3me2a479e">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} whileHover={{
          y: -4
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_10px_30px_rgba(217,155,18,0.2)]' : 'border-mist-dark shadow-sm'} p-8 pl-9 relative overflow-hidden flex flex-col h-full ${index === volumes.length - 1 && volumes.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-283" data-mp="2eebrwl4chv4x" data-mpi={index}>
              <span aria-hidden="true" className="absolute left-0 top-0 bottom-0 w-1.5" style={{
            backgroundColor: volume.accent
          }} data-id="element-284" data-mp="24h7127zk1bhs" />
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-navy-dark font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-285" data-mp="3fxnlkfpyuibi">
                  MOST USED
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-286" data-mp="1btu8otk4gn8n">
                <span className="text-4xl" aria-hidden="true" data-id="element-287" data-mp="1pq7ntw16ocjy">
                  {volume.icon}
                </span>
                <div data-id="element-288" data-mp="1kt7g7goor1qq">
                  <div className="text-gold-dark font-bold text-sm uppercase tracking-wider" data-id="element-289" data-mp="1kqlaznp9oybo">
                    {volume.number} · {volume.lessons}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-navy" data-id="element-290" data-mp="t2t5tufvs7jt">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-navy font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-291" data-mp="120dcjiwiiw1t">
                {volume.subtitle}
              </p>

              <div className="mb-6" data-id="element-292" data-mp="9d95779y65mv">
                <h4 className="text-sm font-bold text-azure uppercase tracking-wider mb-2" data-id="element-293" data-mp="9c7mqhqlqgv4">
                  What does this solve for your coaching?
                </h4>
                <p className="text-slate text-sm leading-relaxed" data-id="element-294" data-mp="2pruloy94ykvf">{volume.problem}</p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-295" data-mp="2c0g0ckrra7l7">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-296" data-mp="2gy7vrorm0bu5">
                    <CheckCircle2 size={18} className="text-success shrink-0 mt-0.5" data-id="element-297" data-mp="34ov2w7tpaxfn" />
                    <span className="text-slate text-sm" data-id="element-298" data-mp="34mqy7nnz9ueb">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-mist border border-mist-dark rounded-xl p-4 mt-auto" data-id="element-299" data-mp="2ur77dfo9tlwf">
                <span className="text-navy font-bold block mb-1" data-id="element-300" data-mp="2zp8t68d2zzbl">Result:</span>
                <p className="text-slate text-sm" data-id="element-301" data-mp="2zrbn33hcucll">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-24" data-id="element-302" data-mp="1obda4oj236f3">
          <div className="text-center mb-12" data-id="element-303" data-mp="1obn38kzedtp0">
            <p className="text-azure font-bold tracking-widest uppercase text-sm mb-3" data-id="element-304" data-mp="23kifzv93s513">
              The 150 Ready-to-Coach Sessions — Organized
            </p>
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-305" data-mp="1yr5rrm8c608v">
              Every Session Has a Clear <span className="text-gold-solid" data-id="element-306" data-mp="1upaoic6uhcsg">Development Area</span>
            </h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-307" data-mp="1pqr62lrgmj4u">
            {sessionAreas.map((area, index) => <motion.div key={area.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="bg-mist border border-mist-dark rounded-2xl p-6" data-id="element-308" data-mp="2igpxuox1gud7" data-mpi={index}>
                <h4 className="text-lg font-serif font-bold text-navy mb-2" data-id="element-309" data-mp="x3wopxpxvzvl">{area.title}</h4>
                <p className="text-slate text-sm leading-relaxed" data-id="element-310" data-mp="mzzqsl24175t">{area.description}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-20 max-w-4xl mx-auto bg-navy rounded-3xl p-8 md:p-12 border border-gold/40" data-id="element-311" data-mp="rzkoks5jn9gy">
          <p className="text-gold-light font-bold tracking-widest uppercase text-sm mb-3 text-center" data-id="element-312" data-mp="15sk4gv98n5p1">
            More Than Just Practice Plans
          </p>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-white text-center mb-8" data-id="element-313" data-mp="1fporsyetl77f">
            Professional Coaching Resources Included Throughout
          </h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-3 mb-8" data-id="element-314" data-mp="3hgjqby0evkhu">
            {coachingResources.map(resource => <div key={resource} className="flex items-start gap-2.5" data-id="element-315" data-mp="3mfwfiper93nl">
                <CheckCircle2 size={16} className="text-gold-light shrink-0 mt-0.5" data-id="element-316" data-mp="3edlzmmwdyms9" />
                <span className="text-white/90 text-sm" data-id="element-317" data-mp="39fu7psvqr0o2">{resource}</span>
              </div>)}
          </div>
          <p className="text-center text-gold-light font-medium" data-id="element-318" data-mp="3odmkwedtfcz3">
            Everything is designed around one goal: help you know what to teach, how to
            progress it and what to work on next.
          </p>
        </motion.div>
      </div>
    </section>;
}